import {Component, OnInit, ViewChild} from '@angular/core';
import {INucleoFamiliar, TipoSolicitudSisben} from "../../../shared/interface/sisben";
import {TramitesSisben} from "../../../shared/classes/TramitesSisben";
import {
  TramRegistroSolicitudService
} from "../../../../../../tramitantes/src/app/services/tramiteRegistroSolicitud.service";
import {TramiteSisbenComponent} from "../../../components/tramite-sisben/tramite-sisben.component";
import {IFormEvent, IFormEventType} from "lib-base";
import {FormGroup} from "@angular/forms";
import { MapperModificarSisben } from '../../../shared/classes/mapper';

@Component({
  selector: 'app-modificar-documento',
  standalone: true,
  imports: [
    TramiteSisbenComponent
  ],
  providers: [
    {provide: TramitesSisben, useExisting: ModificarDocumentoComponent},
    MapperModificarSisben
  ],
  template: `
    <app-tramite-sisben [tipoSolicitud]="tipoSolicitud" [titulo]="titulo"/>`,
})
export class ModificarDocumentoComponent extends TramitesSisben implements OnInit {

  @ViewChild(TramiteSisbenComponent, {static: true}) tramiteSisbenComponent!: TramiteSisbenComponent;

  constructor(protected tramiteRegistroService: TramRegistroSolicitudService,
              protected _mapper: MapperModificarSisben) {
    super("Modificar Documento",
      TipoSolicitudSisben.MODIFICAR_DOCUMENTO,
      tramiteRegistroService,
      _mapper );
  }

  ngOnInit(): void {
    this.tramiteSisbenComponent.eventForm.subscribe((event:any) => {
      this.getChangeSubFormEvent(event)
    })
  }

  public override eliminar(event: any) {
    throw new Error('Method not implemented.');
  }

  public override validate(): boolean {
    if (!this.tramiteSisbenComponent.nucleoFamiliar.length) {
      this.tramiteSisbenComponent.messageService.add({
        severity: 'warn',
        summary: 'Atención',
        detail: 'Seleccione al menos un registro antes de continuar'
      })
      return false;
    }
    return true;
  }

  public override buildParameters(): any {
    if(!this.tramiteSisbenComponent.jefeHogar)
      return null;
    const obj: any = {};
    // @ts-ignore
    this.props().parametros?.forEach((item) => {
      obj[item] = (this.tramiteSisbenComponent.jefeHogar as any)[item] ?? "";
    });
    return obj;
  }

  override modificar(value: INucleoFamiliar): any {
    const data = this.mapper?.fromDtoToEntity(value);
    this.tramiteSisbenComponent.fc.emitSubFormEventAdd().subscribe((event: IFormEvent) => {
      const control = this.getForm(event);
      if (control)
        control.setValue(data);
    });
  }

  private getChangeSubFormEvent(value: IFormEvent): void {
    if (value.eventType == IFormEventType.remove) {
      const control = this.getForm(value);
      if (control) {
        const data = control.getRawValue();
        const predicate = (item: INucleoFamiliar) =>
            item.tipoIdentificacion == data.page1.tipoIdentificacion
            && data.page1.identificacion == item.identificacion;
        this.tramiteSisbenComponent.deleteItem(predicate);
      }
    }
  }



}
